import CaseHistoryModal from './CaseHistoryModal';

export default CaseHistoryModal;
export type { CaseHistoryModalProps } from './CaseHistoryModal';
